(function () {
  function slideToggle(el, show, duration) {
    if (show) {
      el.style.display = 'block';
      el.style.overflow = 'hidden';
      el.style.height = '0';
      el.style.transition = 'height ' + duration + 'ms ease';
      requestAnimationFrame(function() { el.style.height = el.scrollHeight + 'px'; });
      setTimeout(function() { el.style.height = ''; el.style.overflow = ''; el.style.transition = ''; }, duration);
    } else {
      el.style.overflow = 'hidden';
      el.style.height = el.offsetHeight + 'px';
      el.style.transition = 'height ' + duration + 'ms ease';
      requestAnimationFrame(function() { el.style.height = '0'; });
      setTimeout(function() { el.style.display = 'none'; el.style.height = ''; el.style.overflow = ''; el.style.transition = ''; }, duration);
    }
  }
  function initProductAccordion() {
    document.querySelectorAll('.about__accordion-toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var desc = this.parentElement.querySelectorAll('.about__accordion-description');
        if (!this.classList.contains('active')) {
          this.classList.add('active');
          desc.forEach(function(d) { slideToggle(d, true, 300); });
        } else {
          this.classList.remove('active');
          desc.forEach(function(d) { slideToggle(d, false, 300); });
        }
      });
    });
  }
  document.addEventListener('shopify:section:load', initProductAccordion);
  initProductAccordion();
})();
